export function getTokenFromUrl(): string | null {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (token) {
        params.delete('token');
        const newUrl = params.toString() ? `${window.location.pathname}?${params}` : window.location.pathname;
        window.history.replaceState({}, '', newUrl);
    }
    return token;
}
